deleteCallback = ->
  $('.delete-added-field').click ->
    $(this).parent().remove()

$(document).ready ->
  PERSON_FILE_LIMITS = $('#person_file_limits').val() && JSON.parse($('#person_file_limits').val())

  fields = $('.all-fields').children().length
  deleteCallback()

  $('.people-category-sortable').sortable({
    cursor: 'move'
  })
  
  $('.back-chapter-image').click (event) ->
    $('body').prop('scrollTop', 0)
    close = if !!$((event.target)).attr("id") then '#editPeopleImageModal-' + $((event.target)).attr("id") else '#peopleImageModal'
    $('.darkroom-image-container').remove()
    $(close).foundation('reveal', 'close') 
    return
  
  $('.crop-image-back').click (event) ->
    $('body').prop('scrollTop', 0)
    close = if !!$((event.target)).attr("id") then '#editPeopleImageModal-' + $((event.target)).attr("id") else '#peopleImageModal'
    $('.darkroom-image-container').remove()
    $(close).foundation('reveal', 'close') 
    return  
    
  file_preview = $(".upload-preview img")
  fileObject = {}
  
  $("#person_image").change (event) ->
    file_preview = $(event.target).siblings(".image-preview").find(".upload-preview-ipad > img")
    $(".image-preview > #default").css("display", "none")
    $("#openPeopleImageModal").css("display", "inline-block")
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    
    return if fileSizeNotInLimit(file,event,"#openPeopleImageModal",PERSON_FILE_LIMITS["image"])

    
    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return
    
  $('#openPeopleImageModal').click ->    
    $('.darkroom-image-container').remove()
    cropbox = '#image_page_image_cropbox'
    $(cropbox).attr "src", $($(event.target)[0]).parent().children().first().children().first().find(".upload-preview-ipad > img").attr("src")
    $(".upload-preview").removeClass "upload-preview"
    $(".upload-preview-ipad").addClass "upload-preview"
    
  $('#new_person').submit (e) ->
    all_fields = {}
    e.preventDefault()
    image_path = ''

    # Only a freshly uploaded file is a data URI; an asset library image is a proxied URL
    preview_src = $(this).find(".add-upload-preview-ipad img").attr('src')
    if preview_src? and preview_src.indexOf('data:image') == 0
      image_path = preview_src.replace(/^data:image\/[^,]+,/, "")

    asset_id_for_images = {}
    for asset_id in $(this).find('input[id^="asset-id-person-image"]')
      name = $(asset_id).attr("name")
      key  = name.substring(name.lastIndexOf("[")+1, name.length-1)
      asset_id_for_images[key] = $(asset_id).val()

    $('.all-fields .field').each (index) ->
      all_fields[index] = {
        title: $($($('.all-fields .field')[index]).find('input')[0]).val(),
        value: $($($('.all-fields .field')[index]).find('input')[1]).val(),
      }
      
    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',      
      data: 
        'person[custom_image][base64]': image_path
        'person[custom_image][filetype]': fileObject.filetype
        'person[custom_image][filename]': fileObject.filename
        'person[first_name]': $(this).find('#person_first_name').val()
        'person[last_name]': $(this).find('#person_last_name').val()
        'person[job_title]': $(this).find('#person_job_title').val()
        'person[department]': $(this).find('#person_department').val()
        'person[description]': CKEDITOR.instances['new_person_description'].getData()
        'person[email]': $(this).find('#person_email').val()
        'person[phone_number]': $(this).find('#person_phone_number').val()
        'person[twitter]': $(this).find('#person_twitter').val()
        'person[linkedin]': $(this).find('#person_linkedin').val()
        'person[facebook]': $(this).find('#person_facebook').val()
        'person[instagram]': $(this).find('#person_instagram').val()
        'person[people_category_id]': $(this).find('#person_people_category_id').val()
        'person[people_type_id]': $(this).find('#person_people_type_id').val()
        'person[custom_fields]': all_fields
        'person[asset_id_for_images]': asset_id_for_images
        'authenticity_token': $(this).find('input[name=authenticity_token]').val()

    ).done((data, textStatus, jqXHR) ->
      window.location.href = window.location.href.split("functions")[0] + "functions/" + $('#function_id').val() + '/people'
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
        alert(jqXHR.responseText)
        $("#update > input").val('Update')
        $("#update > input").attr('disabled', false)
        return
    )
    false
    
  $('form[id^="edit_person_"]').submit (e) ->
    all_fields = {}
    e.preventDefault()
    image_path = ''
      
    # Only a freshly uploaded file is a data URI; an asset library image is a proxied URL
    preview_src = $(this).find(".upload-preview-ipad img").attr('src')
    if preview_src? and preview_src.indexOf('data:image') == 0
      image_path = preview_src.replace(/^data:image\/[^,]+,/, "")

    asset_id_for_images = {}
    for asset_id in $(this).find('input[id^="asset-id-person-image"]')
      name = $(asset_id).attr("name")
      key  = name.substring(name.lastIndexOf("[")+1, name.length-1)
      asset_id_for_images[key] = $(asset_id).val()

    $('.all-fields .field').each (index) ->
      all_fields[index] = {
        title: $($($('.all-fields .field')[index]).find('input')[0]).val(),
        value: $($($('.all-fields .field')[index]).find('input')[1]).val(),
      }
      
    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',      
      data: 
        'person[custom_image][base64]': image_path
        'person[custom_image][filetype]': fileObject.filetype
        'person[custom_image][filename]': fileObject.filename
        'person[first_name]': $(this).find('#person_first_name').val()
        'person[last_name]': $(this).find('#person_last_name').val()
        'person[job_title]': $(this).find('#person_job_title').val()
        'person[department]': $(this).find('#person_department').val()
        'person[description]': $(this).find('#person_description').val()
        'person[email]': $(this).find('#person_email').val()
        'person[phone_number]': $(this).find('#person_phone_number').val()
        'person[twitter]': $(this).find('#person_twitter').val()
        'person[linkedin]': $(this).find('#person_linkedin').val()
        'person[facebook]': $(this).find('#person_facebook').val()
        'person[instagram]': $(this).find('#person_instagram').val()
        'person[people_category_id]': $(this).find('#person_people_category_id').val()
        'person[people_type_id]': $(this).find('#person_people_type_id').val()
        'person[custom_fields]': all_fields
        'person[asset_id_for_images]': asset_id_for_images
        'authenticity_token': $(this).find('input[name=authenticity_token]').val()
        '_method': 'patch'
        
    ).done((data, textStatus, jqXHR) ->
      window.location.href = window.location.href.split("functions")[0] + "functions/" + $('#function_id').val() + '/people'
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
        alert(jqXHR.responseText)
        $("#update > input").val('Update')
        $("#update > input").attr('disabled', false)
        return
    )
    false
    
  $('#add-field-button').click ->
    $('.all-fields').append(
        '<div class="field">
          <div class="large-2 columns">Title</div>
          <div class="large-9 columns">
            <input id="person_custom_fields_title_'+fields+'" name="person[custom_fields][title]['+fields+']" type="text">
          </div>
          <span class="large-1 columns fa fa-times-circle delete-added-field text-center"></span>
          <div class="large-2 columns">Details</div>
          <div class="large-9 columns">
            <input id="person_custom_fields_detail_'+fields+'" name="person[custom_fields][detail]['+fields+']" type="text">
          </div>
          <span class="large-1 columns">&nbsp;</span>
          <div class="clearfix"></div>
        </div>'
      )
    fields++
    deleteCallback()
    
  return